<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <div class="d-flex align-items-center justify-content-between mb-3 mt-3">
        <b-button variant="secondary" class="ml-2" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
        </b-button>
        <div class="d-flex" style="gap:8px;">
          <b-button v-if="editMode && puedeEditar" @click.prevent="submitForm" variant="primary">
            <i class="fas fa-save mr-1"></i> {{ $t('guardar') }}
          </b-button>
          <!-- Sin permiso de edición la pantalla queda en modo consulta. -->
          <base-button v-if="puedeEditar" :type="editMode ? 'danger' : 'warning'" @click="cancelEdit">
            {{ editMode ? $t('cancelar') : $t('editar') }}
          </base-button>
        </div>
      </div>

      <b-container style="max-width: 90%; margin: auto;">

        <b-card-header class="border-0">
          <h3 class="mb-0">{{ $t('informacion') }}</h3>
        </b-card-header>
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="4">
              <b-form-group label-for="codigo">
                <template v-slot:label>
                  {{ $t('codigo') }} <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="codigo" v-model="unidad.codigo" required
                  :placeholder="$t('codigo')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('unid_codigo_en')" label-for="codigoEn">
                <b-form-input :disabled="!editMode" id="codigoEn" v-model="unidad['codigoEn']"
                  :placeholder="$t('unid_codigo_en')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group label-for="nombre">
                <template v-slot:label>
                  {{ $t('nombre') }} <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="nombre" v-model="unidad.nombre" required
                  :placeholder="$t('nombre')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('unid_nombre_en')" label-for="nombreEn">
                <b-form-input :disabled="!editMode" id="nombreEn" v-model="unidad['nombreEn']"
                  :placeholder="$t('unid_nombre_en')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label-for="simbolo">
                <template v-slot:label>
                  {{ $t('unid_simbolo') }} <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="simbolo" v-model="unidad.simbolo" required
                  :placeholder="$t('unid_simbolo')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group label-for="tipo">
                <template v-slot:label>
                  {{ $t('tipo') }} <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="tipo" v-model="unidad.tipo" required
                  :placeholder="$t('tipo')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('unid_tipo_en')" label-for="tipoEn">
                <b-form-input :disabled="!editMode" id="tipoEn" v-model="unidad['tipoEn']"
                  :placeholder="$t('unid_tipo_en')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('orden')" label-for="orden">
                <b-form-input :disabled="!editMode" id="orden" type="number" v-model.number="unidad.orden"
                  :placeholder="$t('orden')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group :label="$t('unid_factor_conversion')" label-for="factorConversionBase">
                <b-form-input :disabled="!editMode" id="factorConversionBase" type="number" step="any" v-model.number="unidad.factorConversionBase"
                  :placeholder="$t('unid_factor_conversion')"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group :label="$t('unid_id_unidad_base')" label-for="idUnidadBase">
                <b-form-input :disabled="!editMode" id="idUnidadBase" type="number" v-model.number="unidad.idUnidadBase"
                  :placeholder="$t('unid_id_unidad_base')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4" class="mb-3">
              <b-form-checkbox :disabled="!editMode" v-model="unidad.esBase" switch>
                {{ $t('unid_es_base') }}
              </b-form-checkbox>
            </b-col>
            <b-col md="4" class="mb-3">
              <b-form-checkbox :disabled="!editMode" v-model="unidad.permiteDecimales" switch>
                {{ $t('unid_permite_decimales') }}
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <b-form-group :label="$t('descripcion')" label-for="descripcion">
                <b-form-textarea :disabled="!editMode" id="descripcion" v-model="unidad.descripcion" rows="3"
                  :placeholder="$t('descripcion')"></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group :label="$t('unid_descripcion_en')" label-for="descripcionEn">
                <b-form-textarea :disabled="!editMode" id="descripcionEn" v-model="unidad['descripcionEn']" rows="3"
                  :placeholder="$t('unid_descripcion_en')"></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button v-if="editMode && puedeEditar" type="submit" variant="primary" class="ml-3">
            {{ $t('guardar') }}
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import unidadMedidaService from '@/api/unidadMedidaService';
import utilsService from '@/api/utilsService';
import Swal from 'sweetalert2';

export default {
  name: 'UnidadMedidaDetalle',
  data() {
    return {
      unidad: {},
      editMode: false,
    };
  },
  computed: {
    puedeEditar() {
      return utilsService.puedeEscribir() && utilsService.getRol() !== 'ventas inex';
    },
  },
  async beforeMount() {
    const id = this.$route.params.id;
    this.unidad = await unidadMedidaService.get(id);
  },
  methods: {
    async cancelEdit() {
      if (this.editMode) {
        const id = this.$route.params.id;
        this.unidad = await unidadMedidaService.get(id);
      }
      this.editMode = !this.editMode;
    },
    submitForm() {
      if (!this.puedeEditar) return;
      Swal.fire({
        title: this.$t('esta_seguro'),
        text: this.$t('revisa_datos'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('actualizar'),
        cancelButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                    '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                    `<div><h3 style="color:#006393;">${this.$t('actualizando')}</h3></div>` +
                    '</div>',
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            const id = this.$route.params.id;
            const response = await unidadMedidaService.update(this.unidad, id);
            if (!response) {
              Swal.fire({ icon: 'error', title: 'Oops...', text: this.$t('error_inesperado') });
              return;
            }

            Swal.fire({
              title: this.$t('actualizado_correctamente'),
              icon: 'success',
              showConfirmButton: false,
              timer: 2000,
            });
            this.editMode = false;
            this.unidad = await unidadMedidaService.get(id);
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: (error && error.message) ? error.message : this.$t('error_inesperado'),
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    },
  },
};
</script>
